import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Typography,
	Grid,
	Chip,
	Menu,
	MenuItem,
	Button,
} from '@material-ui/core';
import {
	Edit as EditIcon,
	MoreVert as MoreIcon,
	Close as CloseIcon,
	NavigateBeforeOutlined as BackIcon,
	RemoveRedEye as ViewIcon,
} from '@material-ui/icons';
import { MyPATExpansionPanel, MyPATIconButton, MyPATDialog } from '../../common';
import AddMiniLibraryDialog from '../components/AddMiniLibraryDialog';
import ViewMiniLibraryDialog from '../components/ViewMiniLibraryDialog';

import MiniLibraryDetails from '../types/MiniLibraryDetails';
import ContentTypeData from '../../mylibrary/types/ContentTypeData';
import ContentSubtypeData from '../../mylibrary/types/ContentSubtypeData';
import { MiniLibraryBody } from '../types/MiniLibraryBody';

import { contentTypeList } from '../../mylibrary/actions/contentTypeActions';
import contentSubtypeList from '../../mylibrary/actions/contentSubtypeActions';
import { miniLibraryList, getMiniLibraryCount, miniLibraryDetails } from '../actions/miniLibrariesActions';

import miniLibraryServices from '../services/miniLibraryServices';
import ACLService from '../../acl/services/aclService'


const styles = (theme: Theme) => createStyles({
	textCenter: {
		textAlign: 'center',
	},
	textCapitalize: {
		textTransform: 'capitalize'
	},
	fwNormal: {
		fontWeight: theme.typography.fontWeightRegular,
	},
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	mb1x5x: {
		marginBottom: theme.spacing.unit * 1.5,
	},
	mr1x: {
		marginRight: theme.spacing.unit,
	},
	cursorPointer: {
		cursor: 'pointer',
	},
	commaSeparation: {
		'&:after': {
			content: '", "',
		},
		'&:last-child:after': {
			display: 'none',
		}
	},

	miniLibrariesGridBox: {
		paddingTop: theme.spacing.unit,
		paddingBottom: theme.spacing.unit,
	},

	iconBox: {
		paddingRight: `${theme.spacing.unit * 2.5}px !important`,
	},
	libraryIconBox: {
		padding: theme.spacing.unit,
		borderRadius: '100%',
		width: theme.spacing.unit * 8.5,
		height: theme.spacing.unit * 8.5,
		border: `1px solid #FFA19C`,
	},
	libraryIcon: {
		maxWidth: '100%',
		margin: '0 auto',
		display: 'block',
		padding: theme.spacing.unit,
	},

	descriptionBox: {
		paddingLeft: `${theme.spacing.unit}px !important`,
		borderLeft: `1px solid ${theme.palette.grey[400]}`,
	},

	detailsContainer: {
		padding: `${theme.spacing.unit * 2}px 0`,
		marginBottom: theme.spacing.unit * 2,
		borderBottom: `1px solid ${theme.palette.grey[300]}`,
		position: 'relative',
		'&:after': {
			content: '"and"',
			fontFamily: theme.typography.fontFamily,
			position: 'absolute',
			bottom: 0,
			fontSize: theme.typography.fontSize,
			padding: `0 ${theme.spacing.unit * 1.5}px`,
			left: '50%',
			transform: 'translateX(-50%) translateY(50%)',
			display: 'inline-block',
			backgroundColor: theme.palette.common.white,
		},
		'&:last-child': {
			borderBottom: 0,
			'&:after': {
				display: 'none',
			}
		}
	},
	breadcrumbList: {
		padding: 0,
		margin: 0,
		'& > li': {
			...theme.typography.body1,
			display: 'inline-block',
			color: theme.palette.text.primary,
			'&:after': {
				content: '">"',
				margin: `0 ${theme.spacing.unit}px`,
			},
			'&:last-child:after': {
				display: 'none',
			}
		}
	},
	chipsBox: {
		'& > div': {
			marginLeft: theme.spacing.unit,
			height: theme.spacing.unit * 3.5,
			'& > span': {
				fontSize: '0.7rem',
				paddingLeft: theme.spacing.unit * 2,
			},
		}
	},

	moreMenu: {
		'& li': {
			height: theme.spacing.unit * 2,
			color: theme.palette.text.secondary,
			fontSize: '0.8rem',
			paddingTop: theme.spacing.unit,
			paddingBottom: theme.spacing.unit,
			'& > svg': {
				marginRight: theme.spacing.unit,
				fontSize: '1rem',
			}
		}
	},

	backIconRoot: {
		fill: theme.palette.text.secondary,
		fontSize: 24,
		opacity: 0.5,
		marginBottom: 3
	},
});

interface MiniLibrariesContainerProps extends WithStyles<typeof styles> {
	miniLibrary: {
		list: MiniLibraryBody[],
		count: number,
		libDetails: MiniLibraryDetails,
	},
	contentTypes: ContentTypeData[],
	contentSubtypes: ContentSubtypeData[],
	miniLibraryList: () => void,
	contentTypeList: () => void,
	getMiniLibraryCount: () => void,
	onEditClick: () => void,
	miniLibraryDetails: (lib: any) => void,
	contentSubTypeList: () => void,
	history: any,
}

interface MiniLibrariesContainerState {
	isDeleteDialogOpen: boolean,
	libId: string,
	libName: string,
	anchorEl: any,
	openMenu: string,
	expandedLib: any,
	addMiniLibraryDialog: boolean,
	editMiniLibraryId: string,
	isViewLibDialogOpen: boolean,
}

class MiniLibrariesContainer extends Component<MiniLibrariesContainerProps, MiniLibrariesContainerState> {
	constructor(props: MiniLibrariesContainerProps) {
		super(props);
		this.state = {
			isDeleteDialogOpen: false,
			libId: '',
			libName: '',
			anchorEl: null,
			openMenu: '',
			expandedLib: '',
			addMiniLibraryDialog: false,
			editMiniLibraryId: "",
			isViewLibDialogOpen: false,
		};

		this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
		this.handleConfirmDeleteDialogClose = this.handleConfirmDeleteDialogClose.bind(this);
	}

	componentDidMount() {
		_.isEmpty(this.props.miniLibrary.list) && this.props.miniLibraryList();
		_.isEmpty(this.props.contentSubtypes) && this.props.contentSubTypeList();
		_.isEmpty(this.props.contentTypes) && this.props.contentTypeList();
	}

	handleMoreMenuOpen = (evt: any, target: string, expandedLibId: string) => {
		evt.stopPropagation();
		const lib: any = _.find(this.props.miniLibrary.list, ['_id', expandedLibId]);
		if (!lib.isDataUpdated) {
			this.props.miniLibraryDetails(lib);
		}
		this.setState({ anchorEl: evt.currentTarget, openMenu: target });
	};

	handleMoreMenuClose = (evt: any) => {
		evt.stopPropagation();
		this.setState({ anchorEl: null, openMenu: '' })
	};

	handleConfirmDeleteDialogOpen = (libId: string, libName: string, evt: any) => {
		evt.stopPropagation();
		this.handleMoreMenuClose(evt);
		this.setState({
			isDeleteDialogOpen: true,
			libId,
			libName,
		});
	};

	handleAddMiniLibraryOpen = (miniId: string, e: any) => this.setState({ editMiniLibraryId: miniId, addMiniLibraryDialog: true });

	handleDialogCloseMini = (e: any) => this.setState({ editMiniLibraryId: "", addMiniLibraryDialog: false })

	handleConfirmDeleteDialogClose = () => this.setState({
		isDeleteDialogOpen: false,
		libId: '',
		libName: '',
	});

	handleConfirmDelete = (evt: any) => {
		miniLibraryServices.remove(this.state.libId, this.state.libName).then(res => {
			this.props.miniLibraryList();
			this.props.getMiniLibraryCount();
			this.handleConfirmDeleteDialogClose();
		});
	};

	generateSpan = (label: string, val: any) => <span className={this.props.classes.commaSeparation} key={label}>{val} {label}</span>;

	getContentCounts = ({ total: any, ...contentCounts }: any) => {
		let countText: any = [];
		if (_.isEmpty(this.props.contentTypes)) { return '' };
		for (let key in contentCounts) {
			const keyVal = contentCounts[key];
			if (keyVal > 0) {
				const countLabel = _.get(_.find(this.props.contentTypes, ['code', key]), 'name', '');
				countText.push(this.generateSpan(countLabel, keyVal));
			}
		}
		return countText;
	};

	handleDetailsToggle = (lib: any, expandedLibId: string) => (evt: any, expanded: boolean) => {
		if (expanded) {
			if (!lib.isDataUpdated) {
				this.props.miniLibraryDetails(lib);
			}
			return this.setState({
				expandedLib: expandedLibId
			})
		}

		return this.setState({
			expandedLib: false
		});
	}

	getFormattedContent = () => {
		const { list } = this.props.miniLibrary;
		const { expandedLib } = this.state;
		const library: any = _.find(list, ['_id', expandedLib]);
		let formattedContent: any = {};

		const getTypeCodeName = (code: any) => _.get(_.find(this.props.contentTypes, ['code', code]), 'name', '');
		const getSubTypeCodeName = (code: any) => _.get(_.find(this.props.contentSubtypes, ['code', code]), 'name', '');

		if (library['isDataUpdated']) {

			for (let type in library.contentMapped) {
				library.contentMapped[type].map((t: any) => {

					t.subjects && t.subjects.map((sD: any, sI: number) => {

						if (_.isEmpty(_.get(sD, 'subSubjects', []))) {
							return;
						}

						sD.subSubjects.map((ssD: any, ssI: number) => {
							ssD.chapters.map((chD: any, chI: number) => {
								chD.concepts.map((coD: any, coI: number) => {
									let key = `${sD.subjectId.name}-${sD.subjectId._id}`;

									if (ssD.subSubjectId) {
										key += `|${coD.classId.name}-${coD.classId._id}|${ssD.subSubjectId.name}-${ssD.subSubjectId._id}`;
									}

									if (!formattedContent[key]) {
										formattedContent[key] = [];
									}

									let data: any = {
										contentType: [],
										count: 0,
									};
									if(formattedContent[key]['contentType'] && formattedContent[key]['contentType'].length>0){
										data.contentType = formattedContent[key]['contentType'];
									}
									if (type !== 'question') {
										if(!data.contentType.includes(getTypeCodeName(t.contentTypeCode)))
										data.contentType.push(getTypeCodeName(t.contentTypeCode));
										data.count = formattedContent[key]['count'] ? formattedContent[key]['count'] + 1 : 1;
									} else {
										if(!data.contentType.includes(getSubTypeCodeName(t.contentSubTypeCode)))
										data.contentType.push(getSubTypeCodeName(t.contentSubTypeCode));
										data.count = formattedContent[key]['count'] ? formattedContent[key]['count'] + 1 : 1;
									}

									formattedContent[key] = data;
								})
							})
						})
					})
				})
			}
		}
		return formattedContent;
	}

	handleViewLibraryDialogOpen = (libId: string, libName: string, evt: any) => {
		evt.stopPropagation();
		return this.setState({
			isViewLibDialogOpen: true,
			libId,
			libName,
		});
	}

	handleViewLibraryDialogClose = (evt: any) => {
		this.handleMoreMenuClose(evt);
		return this.setState({
			isViewLibDialogOpen: false,
			libId: '',
			libName: '',
		})
	};

	render() {
		const {
			anchorEl,
			openMenu,
			isDeleteDialogOpen,
			libName,
			libId,
			expandedLib,
			addMiniLibraryDialog,
			editMiniLibraryId,
			isViewLibDialogOpen
		} = this.state;

		const {
			classes,
			miniLibrary,
			history,
		} = this.props;


		const detailsData = expandedLib ? this.getFormattedContent() : [];

		const generateBreadcrumb = (key: string) => {
			const classSubjectSubSubject = key.split('|');
			let breadcrumb: any = '';
			if (classSubjectSubSubject.length > 1) {
				const subject = classSubjectSubSubject[0].split('-');
				const clas = classSubjectSubSubject[1].split('-');
				const subSubject = classSubjectSubSubject[2].split('-');
				breadcrumb = (
					<>
						<li>Class {clas[0]}</li>
						<li>{subject[0]}</li>
						<li>{subSubject[0]}</li>
					</>
				)
			}
			return breadcrumb;
		}

		const selectedContent = () => {
			let data: any = [];
			for (let key in detailsData) {
				data.push(
					<Grid
						key={key}
						container spacing={8} className={classes.detailsContainer}
					>
						<Grid item xs={12}>
							<Typography variant="body1" color="textSecondary">{detailsData[key].count} Selected Content Items In:</Typography>
						</Grid>
						<Grid item xs={12} className={classes.mb1x}>
							<ul className={classes.breadcrumbList}>
								{generateBreadcrumb(key)}
							</ul>
						</Grid>
						<Grid item xs={12} className={classes.chipsBox}>
							{_.map(detailsData[key].contentType, (type: string, i: number) => (
								<Chip key={`chip-${type}-${i}`} label={type} />
							))}
						</Grid>
					</Grid>
				)
			}
			return data;
		}

		return (
			<>
				{_.map(miniLibrary.list, (library, index) => (
					<MyPATExpansionPanel
						key={index}
						defaultExpanded={false}
						variant="white"
						panelProps={{
							className: classes.mb1x5x,
							onChange: this.handleDetailsToggle(library, library._id),
							expanded: expandedLib === library._id
						}}
						customCollapseTitle={
							<Grid container alignItems="center"
								justify="space-between" spacing={8}
								className={classes.miniLibrariesGridBox}
							>
								<Grid item xs="auto" className={classes.iconBox}>
									<div className={classes.libraryIconBox}>
										<img src="assets/img/userManagement/book.png" className={classes.libraryIcon} />
									</div>
								</Grid>
								<Grid item xs className={classes.descriptionBox}>
									<Typography variant="h6" className={classes.textCapitalize}>
										{library.name}
									</Typography>
									<Typography variant="body2" className={classes.textCapitalize}>
										{library.description}
									</Typography>
									<Typography variant="body2" className={classes.fwNormal}>
										{library.contentCounts.total} Content Items
										({this.getContentCounts(library.contentCounts)})
									</Typography>
								</Grid>
								<Grid item xs="auto">
									<MyPATIconButton onClick={(e: any) => { this.handleMoreMenuOpen(e, `menu-${library._id}`, library._id) }}>
										<MoreIcon />
									</MyPATIconButton>
									<Menu
										id={`menu-${library._id}`}
										anchorEl={anchorEl}
										open={_.isEqual(`menu-${library._id}`, openMenu) ? true : false}
										onClose={(evt: any) => { this.handleMoreMenuClose(evt) }}
										className={classes.moreMenu}
									>
										{/* {
											ACLService.hasAccessTo(['CONTENTSETTING'], ['EDIT']) &&
											<MenuItem id={library._id} onClick={this.handleAddMiniLibraryOpen.bind(this, library._id)}>
												<EditIcon /> Edit
											</MenuItem>
										} */}
										{/* {
											ACLService.hasAccessTo(['CONTENTSETTING'], ['DELETE']) &&
											<MenuItem onClick={(e: any) => { this.handleConfirmDeleteDialogOpen(library._id, library.name, e) }}>
												<CloseIcon /> Delete
											</MenuItem>
										} */}

										<MenuItem onClick={(e: any) => { this.handleViewLibraryDialogOpen(library._id, library.name, e) }}>
											<ViewIcon /> View Library
										</MenuItem>
									</Menu>
								</Grid>
							</Grid>
						}
					>
						<Grid container alignItems="center">
							<Grid item xs={12}>
								<Typography variant="h6" className={classes.fwNormal}>Content</Typography>
							</Grid>
							<Grid item xs={12}>
								{selectedContent()}
							</Grid>
						</Grid>
					</MyPATExpansionPanel>
				))}

				<MyPATDialog
					dialogOpen={isDeleteDialogOpen}
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'sm',
					}}
					customDialogActions={
						<>
							<Button color="primary" onClick={this.handleConfirmDelete.bind(this)} >
								Delete
							</Button>
							<Button
								variant="contained" color="primary"
								onClick={() => this.handleConfirmDeleteDialogClose()}
							>
								Cancel
							</Button>
						</>
					}
				>
					<Typography variant="body1">
						<strong>Are you sure you want to delete "{libName}" permanently?</strong>
					</Typography>
				</MyPATDialog>

				<AddMiniLibraryDialog
					dialogOpen={addMiniLibraryDialog}
					dialogCloseHandler={this.handleDialogCloseMini.bind(this)}
					dialogData={editMiniLibraryId}
				/>

				{isViewLibDialogOpen &&
					<ViewMiniLibraryDialog
						dialogOpen={isViewLibDialogOpen}
						dialogCloseHandler={this.handleViewLibraryDialogClose.bind(this)}
						dialogData={{ libId, libName }}
						history={history}
					/>
				}
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	miniLibrary: _.get(state, 'userManagement.miniLibrary', {}),
	contentTypes: _.get(state, 'mylibraryData.contentType.list', []),
	contentSubtypes: _.get(state, 'mylibraryData.contentSubtype.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	miniLibraryList,
	contentTypeList,
	contentSubTypeList: contentSubtypeList.list,
	getMiniLibraryCount,
	miniLibraryDetails,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MiniLibrariesContainer));